<template>
  <v-container style="max-width:1000px;" class="mt-8">
    <h1>404</h1>
    <p>Ooops, something went wrong and we can't find the requested page.</p>
    <v-img src="../assets/sad_train.jpg" aspect-ratio="1.7" contain class="my-8"></v-img>
        <v-btn class="ma-2 textSecondary--text" tile color="secondary" :to="{ name: 'home'}">
      <v-icon left>mdi-home</v-icon> Back to Main Page
    </v-btn>
  </v-container>
</template>

<script>

export default {
  name: 'PageNotFound'
}
</script>
